<template>
	<div class="flex flex-col gap-[23px] justify-start items-start py-[40.5px] px-[35px] bg-[--white] rounded-[8px] max-w-[402px] ">

    <div class="flex flex-row gap-[10px] items-center justify-start">
      <img :src="card.avatarSrc" alt="avatar" class="w-50 h-50 rounded-full" />
      
      <div class="felx flex-col gap-[8px]">
        <h3 class="text-[15px] leading-[132%]" v-text="card.title"></h3>
        <div class="flex items-center">
          <img src="/img/icons/star-yellow.svg" alt="avatar" class="w-[15px] h-[15px] rounded-full" />
          <img src="/img/icons/star-yellow.svg" alt="avatar" class="w-[15px] h-[15px] rounded-full" />
          <img src="/img/icons/star-yellow.svg" alt="avatar" class="w-[15px] h-[15px] rounded-full" />
          <img src="/img/icons/star-yellow.svg" alt="avatar" class="w-[15px] h-[15px] rounded-full" />
          <img src="/img/icons/star-yellow.svg" alt="avatar" class="w-[15px] h-[15px] rounded-full" />
          <span class="ml-[8px] leading-[132%] text-[11px] font-extralight ">via Google Reviews</span>
        </div>
      </div>
    </div>
		<p class="font-light leading-[132%]" v-html="card.text"></p> 
	</div>
</template>
<script>
export default {
	name: 'CardComponent',
	props: {
		card: {
			type: Object,
			required: true
		}
	}
}
</script>
